/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react';
import { Alert, Avatar, Box, Button, Grid, LinearProgress, Paper, Snackbar, SnackbarCloseReason, TextField, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
import { VTextField, VForm, useVForm, IVFormErrors, AutoCompleteFuncionario, VTextFieldData, VFieldMoney, AutoCompletePeriodo, BasicSelect } from '../../../shared/forms';
import { FerramentasDeDetalhe } from '../../../shared/components';
import { LayoutBaseDePagina } from '../../../shared/layouts';
import dayjs from 'dayjs';
import { dataextenso } from '../../../shared/services/util/dataextenso';
import { Environment } from '../../../shared/environment';
import { EmpFunService, IDetalheEmpCreate, IFormDataParcelasEmpFun } from '../../../shared/services/api/rh/EmpFun/EmpFunService';
import { DialogEmpFun } from './DialogEmpFun';
import { BaixaEmpFun } from './BaixaEmpFun';

const formValidationSchema: yup.ObjectSchema<Omit<IDetalheEmpCreate, 'idoperacao' | 'vtotal'>> = yup.object().shape({
  idfun: yup.string().required(),
  valor: yup.number().required().moreThan(0),
  historico: yup.string().optional().default(''),
  periodo: yup.string().required().min(7).max(40),
  parcela: yup.string().required(),
  datalan: yup.date().required(),
});

export const DetalheDeEmpFun: React.FC = () => {
  const { id = 'novo' } = useParams<'id'>();
  const navigate = useNavigate();
  const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
  const [isLoading, setIsLoading] = useState(false);
  const [nome, setNome] = useState('');
  const [idfun, setIdfun] = useState('');
  const [open, setOpen] = useState(false);
  const [openBaixa, setOpenBaixa] = useState(false);
  const [value, setValue] = useState('');
  const [urlimg, setUrlimg] = useState('');
  const [dadosparcelamento, setDadosParcelamento] = useState<IDetalheEmpCreate>({} as IDetalheEmpCreate);
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');
  const [status, setStatus] = useState(false);

  const [openConfirm, setOpenConfirm] = useState(false);

  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
    if (tms === 'success') {
      navigate('/empfun');
    }
  };

  const handleDelete = (id: string) => {
    setOpenConfirm(true);
  };

  const handleConfirmDelete = () => {
    EmpFunService.deleteById(id)
      .then(result => {
        if (result instanceof Error) {
          setOpenConfirm(false);
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          setOpenConfirm(false);
          setTms('success');
          setMsg('Registro apagado com sucesso!');
          setOpenmsg(true);
        }
      });
  };

  const handleCancelDelete = () => {
    setOpenConfirm(false);
  };

  useEffect(() => {
    if (id !== 'novo') {
      setIsLoading(true);
      EmpFunService.getById(id)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
          } else {
            setIdfun(result.idfun);
            if (result.urlimg != null) {
              setUrlimg(Environment.URL_IMGFUNCIONARIO + result.urlimg);
            }
            formRef.current?.setData(result);
            setNome(result.nome);
            setStatus(result.status);
          }
        });
    } else {
      formRef.current?.setData({
        idfun: '',
        valor: 0.00,
        totalvale: 0.00,
        realizacao: '',
        historico: '',
        periodo: dataextenso(new Date()),
        financeiro: 'sim',
        datalan: dayjs(),
        parcela: 1,
      });
    }
  }, [id]);

  const handlefoto = (urlimg: string | undefined) => {
    if (urlimg != null) {
      setUrlimg(Environment.URL_IMGFUNCIONARIO + urlimg);
    }
  };

  const handleSave = (dados: IDetalheEmpCreate) => {
    if (id !== 'novo') {
      dados.idfun = idfun;
    }
    formValidationSchema.
      validate(dados, { abortEarly: false })
      .then((dadosValidados) => {
        setIsLoading(true);
        if (id === 'novo') {
          if (Number(dados.parcela) > 1) {
            const total = dados.valor;
            setDadosParcelamento(dados);
            setOpen(true);
          } else {
            EmpFunService
              .create(dadosValidados)
              .then((result) => {
                setIsLoading(false);
                if (result instanceof Error) {
                  setTms('error');
                  setMsg(result.message);
                  setOpenmsg(true);
                }else{
                  setTms('success');
                  setMsg('Lançamento Realizado com sucesso!');
                  setOpenmsg(true);
                }
              });
          }
        } else {
          EmpFunService
            .updateById(id, dados)
            .then((result) => {
              setIsLoading(false);
              if (result instanceof Error) {
                setTms('error');
                setMsg(result.message);
                setOpenmsg(true);
              } else {
                setTms('success');
                setMsg('Alteração concluída com sucesso!');
                setOpenmsg(true);
              }
            });
        }
      })
      .catch((errors: yup.ValidationError) => {
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      });
  };

  const handleClose = (newValue?: string) => {
    setOpen(false);

    if (newValue) {
      setValue(newValue);
    }
  };
  const handleCloseBaixa = (newValue?: string) => {
    setOpenBaixa(false);

    if (newValue) {
      setValue(newValue);
    }
  };
  const handleBaixa = (newValue?: string) => {
    setOpenBaixa(true);

    if (newValue) {
      setValue(newValue);
    }
  };
  return (
    <LayoutBaseDePagina
      titulo={id === 'novo' ? 'Novo Empréstimo Colaborador' : nome}
      barraDeFerramentas={
        <FerramentasDeDetalhe
          textoBotaoNovo='Novo'
          mostrarBotaoSalvarEFechar
          mostrarBotaoSalvarCarregando={isLoading}
          mostrarBotaoBaixaCarregando={isLoading}
          mostrarBotaoSalvarEFecharCarregando={isLoading}
          mostrarBotaoNovo={id !== 'novo'}
          mostrarBotaoApagar={id !== 'novo'}
          mostrarBotaoBaixa={id !== 'novo'}
          disableBotaoSalvar={status ? true : isLoading}
          disableBotaoApagar={status ? true : isLoading}
          disableBotaoBaixa={status ? true : isLoading}
          mostrarBotaoImpressao={false}
          mostrarBotaoApagarCarregando={isLoading}
          mostrarBotaoImpressaoCarregando={isLoading}
          aoClicarEmSalvar={save}
          aoClicarEmSalvarEFechar={saveAndClose}
          aoClicarEmBaixa={handleBaixa}
          aoClicarEmVoltar={() => navigate('/empfun')}
          mostrarBotaoVoltarCarregando={isLoading}
          aoClicarEmApagar={() => handleDelete(id)}
          aoClicarEmNovo={() => navigate('/empfun/detalhe/novo')}
          mostrarBotaoNovoCarregando={isLoading}
        />
      }
    >
      <VForm ref={formRef} onSubmit={handleSave}>
        <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={900} onClose={handleCloseMsg}>
          <Alert
            onClose={handleCloseMsg}
            severity={tms}
            variant="filled"
            sx={{ width: '100%' }}
          >
            {msg}
          </Alert>
        </Snackbar>
        <Snackbar open={openConfirm} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert
            severity="warning"
            variant="filled"
            sx={{ display: 'flex', alignItems: 'center', width: '100%' }}
            action={
              <>
                <Button color="inherit" size="small" onClick={handleConfirmDelete}>
                  Sim
                </Button>  
                <Button color="inherit" size="small" onClick={handleCancelDelete}>
                  Nâo
                </Button>
              </>
            }
          >
            Tem certeza que deseja excluir este registro?
          </Alert>
        </Snackbar>
        <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
          <Grid container direction="column" padding={1} spacing={2}>
            {isLoading && (
              <Grid item>
                <LinearProgress variant='indeterminate' />
              </Grid>
            )}
            <Grid item>
              <Typography variant='h6'>Geral</Typography>
            </Grid>
            <Grid container item direction="row" spacing={3}>
              <Grid container item direction="row" spacing={2} >
                <Grid item xs={12} sm={12} md={2} lg={2} xl={2} >
                  <Box width="100%" marginRight={5} >
                    <Avatar
                      variant='rounded'
                      alt='F'
                      src={urlimg}
                      sx={{ width: '100%', height: 200 }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    {id === 'novo' ? (
                      <AutoCompleteFuncionario
                        isExternalLoading={id === 'novo' ? isLoading : true}
                        urlfoto={handlefoto}
                      />
                    ) : (
                      <TextField
                        fullWidth
                        size='small'
                        value={nome}
                        label='Nome do Funcionario'
                        disabled={true}
                      />
                    )}
                  </Grid>
                  <Grid container item direction="row" marginTop={0} spacing={1.5} >
                    <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                      <VTextFieldData
                        fullWidth
                        name='datalan'
                        label='Data Lancamento'
                        disabled={id === 'novo' ? isLoading : true}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                      <AutoCompletePeriodo isExternalLoading={status ? true : isLoading} />
                    </Grid>
                    <Grid item xs={6} sm={6} md={2} lg={2} xl={2}>
                      {id === 'novo' ? (
                        <VTextField
                          fullWidth
                          type='number'
                          size='small'
                          name='parcela'
                          label='Parcela'
                          disabled={false}
                        />
                      ) : (
                        <VTextField
                          fullWidth
                          size='small'
                          name='parcela'
                          label='Parcela'
                          disabled={true}
                        />
                      )}
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3} xl={3}>
                      <VFieldMoney
                        fullWidth
                        size='small'
                        name='valor'
                        label='Valor'
                        disabled={status ? true : isLoading}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <VTextField
                        fullWidth
                        name='historico'
                        label='Historico'
                        multiline
                        rows={2}
                        disabled={status ? true : isLoading}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <DialogEmpFun
              dados={dadosparcelamento}
              value={''}
              open={open}
              onClose={handleClose}
            />
            <BaixaEmpFun
              value={id}
              open={openBaixa}
              onClose={handleCloseBaixa}
            />
          </Grid>
        </Box>
      </VForm>

    </LayoutBaseDePagina>
  );
};